import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Home from './pages/home';
import Pagcursos from './pages/cursos';
import Pagmentorias from './pages/mentorias';
import Single from './pages/single';
import NotFound from './pages/not_found';
import Pagnoticias from './pages/noticias';
import Pagvagas from './pages/vagas';
import Secretario from './components/A-Secretaria/o-secretario';
import Organograma from './components/A-Secretaria/organograma';
import Ouvidoria from './components/A-Secretaria/ouvidoria';
import Pagparceiros from './pages/parceiros';
import Pagfaq from './pages/faq';
import Novomenu from './components/Menu/novomenu';

const Routes = () => (
   <BrowserRouter basename="">
      <Novomenu />
      <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/o-secretario" component={Secretario} />
            <Route path="/organograma" component={Organograma} />
            <Route path="/ouvidoria" component={Ouvidoria} />
            <Route path="/noticias" component={Pagnoticias} />
            <Route path="/cursos" component={Pagcursos} />
            <Route path="/mentorias" component={Pagmentorias} />
            <Route path="/vagas" component={Pagvagas} />
            <Route path="/faq" component={Pagfaq} />            
            <Route path="/parceiros" component={Pagparceiros} />
            <Route path="/:tipo/:slug" render={(props) => <Single {...props} />} />
            <Route path="/not_found" component={NotFound} />            
            <Route component={NotFound} />            
      </Switch>
   </BrowserRouter>
);
export default Routes;